/* eslint-disable jsx-a11y/control-has-associated-label */
import { FC } from 'react';
import './personal-account-congratulations.scss';
import { formatNumberWithSpaces } from '@app/utils';
import { NewButton } from '@app/components/NewButton/NewButton';
import { useEnhancedTranslation } from '@app/hooks';

type TProps = {
  giftMessage?: {
    message: string;
    recipientName: string;
    senderName: string;
  };
  nominal: number;
  image: string;
  onClose: () => void;
};

const PersonalAccountCongratulations: FC<TProps> = ({ giftMessage, nominal, image, onClose }) => {
  const { t } = useEnhancedTranslation({ keyPrefix: 'account.personalAccount.congratulationModal' });
  return (
    <div className="personal-account-congratulations">
      <div className="personal-account-congratulations__wrap">
        <div className="personal-account-congratulations__image">
          <img src={image} alt="" />
          <div className="personal-account-congratulations__nominal">
            {formatNumberWithSpaces(nominal.toString())} ₽
          </div>
        </div>
        <div className="personal-account-congratulations__info">
          <div className="personal-account-congratulations__recipient h4">{giftMessage?.recipientName}</div>
          <div className="personal-account-congratulations__message">{giftMessage?.message}</div>
          <div className="personal-account-congratulations__sender">{giftMessage?.senderName}</div>
          <NewButton size="small" onClick={onClose} addClass="personal-account-congratulations__btn">
            {t('close')}
          </NewButton>
        </div>
      </div>
      <button type="button" onClick={onClose} className="personal-account-congratulations__close" title="close">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
          <rect x="30.5859" y="32" width="31.9435" height="1.99647" transform="rotate(-135 30.5859 32)" fill="white" />
          <rect x="8" y="30.5879" width="31.9435" height="1.99647" transform="rotate(-45 8 30.5879)" fill="white" />
        </svg>
      </button>
    </div>
  );
};

export default PersonalAccountCongratulations;
